import { useState } from "react";

const useForm = () => {
  const [values, setValues] = useState({ });
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const auxValues = { ...values };
    auxValues[event.target.name] = event.target.value;
    setValues(auxValues);
  };

  const handleSubmit = callback => event => {
    setLoading(true, () => console.log("loading [callback true]: ", loading));
    event.preventDefault();
    callback();
    setLoading(false, () => console.log("loading [depois callback false]: ", loading));
  };

  return [{ values, loading, setLoading }, handleChange, handleSubmit];
};

export default useForm;